import "./i18n";
import React from "react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { Shadows } from "@material-ui/core/styles/shadows";
import { create } from "jss";
import rtl from "jss-rtl";
import { StylesProvider, jssPreset } from "@material-ui/core/styles";

import { Routes } from "routes";
import GlobalState from "core/context/GlobalState";

const win: any = window;

const isRTL = win["lang"] === "ar";

const apptheme = createMuiTheme({
  direction: "rtl",

  shadows: Array(25).fill("none") as Shadows,
  typography: {
    fontSize: 12,
    fontFamily: isRTL ? "ExpoArabic-Medium" : "ScandiaWeb-Regular",
  },
  palette: {
    text: {
      primary: "#606060",
      secondary: "#72767A",
    },
    primary: {
      main: "#606060",
      light: "#d4d4d0",
      dark: "#efeded",
    },
    secondary: {
      main: "#008CFF",
    },
    contrastThreshold: 3,
  },
});

export default function App() {
  document.body.setAttribute("dir", isRTL ? "rtl" : "ltr");
  const jss = isRTL
    ? create({ plugins: [...jssPreset().plugins, rtl()] })
    : create({ plugins: [...jssPreset().plugins] });

  return (
    <GlobalState>
      <StylesProvider jss={jss}>
        <ThemeProvider theme={apptheme}>
          <Routes />
        </ThemeProvider>
      </StylesProvider>
    </GlobalState>
  );
}
